import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './Public/App';
import { useEffect } from 'react';
import ScrollToTop from "../src/Public/scrollToTop";



ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop />
    <App />
  </BrowserRouter>,
  document.getElementById('root')
)